<ng-container *transloco="let t">
  @if (
    {
      activeLang: activeLang$ | async,
      errorMessage: errorMessage$ | async,
      readOnly: readOnly$ | async,
      helpText: helpText$ | async,
    };
    as data
  ) {
    <div class="form-group question-container-inner" [formGroup]="questionForm">
      <lib-input-container
        [headLine]="
          question.translations?.list['headLine']
            | translate: data.activeLang : question.structure.headLine
        "
        [description]="
          question.translations?.list['description']
            | translate: data.activeLang : question.structure.description
        "
        [labelPrefix]="questionNumber$ | async"
        [label]="
          question.translations?.list['title']
            | translate: data.activeLang : question.title
        "
        [questionMarkText]="
          question.translations?.list['questionMarkText']
            | translate: data.activeLang : question.structure.questionMarkText
        "
        [required]="question.validation.required"
        [errorText]="data.errorMessage"
        [for]="labelPrefix + question.id"
        [inputType]="InputType.Dropdown"
        [width]="width()"
        [helpText]="data.helpText"
        [showChangeIndicator]="
          !data.readOnly &&
          showChanges() &&
          previousAnswersService.hasSimpleValueChanged(
            question.id,
            repeaterGroupId,
            value.value
          )
        "
      >
        @if (!data.readOnly) {
          <lib-vinnova-dropdown
            [id]="labelPrefix + question.id"
            [error]="!!data.errorMessage"
            [required]="question.validation.required"
            formControlName="value"
            [placeholder]="
              question.structure.countryOption ||
              question.structure.organisationOption
                ? placeholder
                : question.structure.placeholder
            "
            [items]="items()"
            [max]="maxNumberCheck() ? maxNumberOfCheckedOptions : undefined"
            [multiple]="question.structure.dropdownMultiple"
          ></lib-vinnova-dropdown>
        }
        @if (data.readOnly) {
          @for (dropdown of readonlyItems(); track $index) {
            <div class="readonly d-flex align-items-center">
              {{ dropdown }}
            </div>
          }
          @if (readonlyItems().length === 0) {
            <div
              class="readonly"
              [ngClass]="
                data.readOnly === ReadonlyState.Locked && value.errors?.required
                  ? 'invalid'
                  : ''
              "
            ></div>
          }
        }
      </lib-input-container>
    </div>
  }
</ng-container>
